import Carousel from "../Carousel/Carousel";
import styles from "./Badminton.module.css";

const badmintonData = [
  {
    id: 1,
    img: require("../../assets/images/badminton-img-1.png"),
    alt: "",
  },
  {
    id: 2,
    img: require("../../assets/images/badminton-img-2.png"),
    alt: "",
  },
  {
    id: 3,
    img: require("../../assets/images/badminton-img-3.png"),
    alt: "",
  },
  {
    id: 4,
    img: require("../../assets/images/badminton-img-4.png"),
    alt: "",
  },
];

const Badminton = () => {
  return <Carousel title="Badminton" data={badmintonData} />;
};

export default Badminton;
